import { Flex, Modal } from 'antd'
import React from 'react'
import { FeatureFlowClassic } from './features/FlowClassic'

type Props = { isOpen: boolean; setOpen: (isOpen: boolean) => void }

export const AuthenticationModal: React.FC<Props> = ({ isOpen, setOpen }) => {
  return (
    <>
      {isOpen && (
        <Modal
          open={true}
          footer={<></>}
          closeIcon={<></>}
          onCancel={() => setOpen(false)}
        >
          <Flex align="center" justify="center">
            <FeatureFlowClassic />
          </Flex>
        </Modal>
      )}
    </>
  )
}
